export default __webpack_public_path__ + "locales/fr/Webhooks.json?hash=69100bc2284574f909b3418d37c985c9";